import { render, staticRenderFns } from "./SettingUpGuide.vue?vue&type=template&id=59f9c9d6&scoped=true"
import script from "./SettingUpGuide.vue?vue&type=script&lang=js"
export * from "./SettingUpGuide.vue?vue&type=script&lang=js"
import style0 from "./SettingUpGuide.vue?vue&type=style&index=0&id=59f9c9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f9c9d6",
  null
  
)

export default component.exports